// declare const qz: any;
// declare const qz: any;
import qz from "qz-tray";


import { AppDispatch } from "../../../store/store";
import {
  setConnectionState,
  setClientVersion,
} from "../../../store/slices/qztray/qzTrayClientSlice";

export const disconnectClientLogic = async (dispatch: AppDispatch) => {
  if (!qz.websocket.isActive()) return;
  await qz.websocket.disconnect();
  // console.log("🧹 Cliente QZ Tray desconectado correctamente.");
  dispatch(setConnectionState({ isConnected: false, endpoint: null }));
  dispatch(setClientVersion(null));
};
